// pages/SalesLanding.tsx

import React from 'react';
import { StickyHeader } from '../components/StickyHeader';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { DemoSection } from '../components/DemoSection';
import { BenefitsSection } from '../components/BenefitsSection';
import { BonusesSection } from '../components/BonusesSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { HowToGetSection } from '../components/HowToGetSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { FinalCtaSection } from '../components/FinalCtaSection';
import { FaqSection } from '../components/FaqSection';
import { Footer } from '../components/Footer';
import { FloatingWhatsApp } from '../components/FloatingWhatsApp';
export function SalesLanding() {
  return <div className="min-h-screen w-full bg-white font-sans text-ink" data-id="element-221" data-mp="gngb113560zx">
      <StickyHeader data-id="element-222" data-mp="gnoj8fobki4s" />
      <main data-id="element-223" data-mp="2nzqini0k10m">
        <HeroSection data-id="element-224" data-mp="2nrfl15gb5s2" />
        <ProblemSection data-id="element-225" data-mp="2p1f7urycm0t" />
        <DemoSection data-id="element-226" data-mp="2pkkoc0f1hxy" />
        <BenefitsSection data-id="element-227" data-mp="2puds8grc57v" />
        <BonusesSection data-id="element-228" data-mp="3u2xbdxsxyi30" />
        <TestimonialsSection data-id="element-229" data-mp="3u1m962f59ie0" />
        <HowToGetSection data-id="element-230" data-mp="3u1duq63di50p" />
        <GuaranteeSection data-id="element-231" data-mp="3q13iwcswgkdx" />
        <FinalCtaSection data-id="element-232" data-mp="3q0akbz43h16v" />
        <FaqSection data-id="element-233" data-mp="3q1lkloybzqt8" />
      </main>
      <Footer data-id="element-234" data-mp="3pypqkbpltma2" />
      <FloatingWhatsApp data-id="element-235" data-mp="3l2919e6o51ve" />
    </div>;
}